<template>
  <el-dialog
    :visible.sync="show"
    append-to-body
    :show-close="false"
    @mousedown.self.native="handleMouseDown"
    @mouseup.self.native="handleMouseUp"
    :close-on-click-modal="false"
    v-bind="
      disableClose ?
      {
        'close-on-press-escape': false,
        ...elProps
      } : elProps"
    @open="open"
    @opened="opened"
    @close="close"
    @closed="closed"
    :before-close="beforeClose"
  >
    <div 
      class="chat-dialog-wrapper" 
      ref="dialog-wrapper"
      :class="theme"
      v-if="!noWrapper"
      @mousedown="mousedown_wrapper_flag = false"
      :style="{
        display: hasSlot ? 'flex' : 'block'
      }">
      <div
        class="close-btn absolute top-[24px] right-[24px] pointer text-tx-3"
        @click.prevent.stop="handleClickCloseBtn"
      >
        <i v-if="closeable" class="iconfont icon-close-bold"></i>
      </div>
      <div class="dialog-title-group" v-if="config.title || config.desc" :class="config.titleClass">
        <slot name="title-left-icon"></slot>
        <div>
          <p v-if="!(config.title instanceof Object)" class="title" v-html="config.title"></p>
          <p v-else class="title">
            <span
              v-for="(fragment, index) in Object.keys(config.title)"
              :key="index"
              :style="{'color': config.title[fragment]}"
            >{{fragment}}</span>
          </p>
          <p class="desc" v-if="config.desc" v-html="config.desc"></p>
          <slot name="header"></slot>
        </div>
      </div>
      <div class="slot-wrapper" :class="'dialog-'+uid" v-if="hasSlot">
        <slot></slot>
      </div>
      <div class="btn-wrapper" :class="{'no-mg': !hasSlot}" v-if="!$slots.footer && (config.cancel || config.confirm || config.textBtn)">
        <div
          v-if="config.textBtn"
          class="text-btn"
          @click.stop="handleTextBtn"
        >{{ config.textBtn.text }}</div>
        <Button 
          v-if="config.cancel"
          :text="config.cancel.text || '取消'" 
          type="cancel" 
          @click.native.stop="handleCancel" 
          class="btn"
          :style="config.cancel.style"
          :disabled="config.cancel.disabled"
        ></Button>
        <Button 
          v-if="config.confirm"
          :type="config.confirm.type || ''"
          :text="config.confirm.text || '确定'"
          @click.native.stop="confirmCallBack" 
          class="btn"
          :loading="config.confirm.loading"
          :style="config.confirm.style"
          :disabled="config.confirm.disabled"
          :success="config.confirm.success"
        ></Button>
      </div>
      <div class="btn-wrapper" v-if="$slots && $slots.footer">
        <slot name="footer"></slot>
      </div>
      <div class="never-show-row" v-if="config.neverShow" @click="is_never_show = !is_never_show">
        <div class="radio" :class="{active: is_never_show}" >
          <i class="iconfont icon-toast-success-square" v-if="is_never_show"></i>
        </div>
        <p>{{ config.neverShow?.text || '不再显示' }}</p>
      </div>
    </div>
    <template v-else>
      <slot></slot>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: 'Dialog',
  props: {
    value: {},
    config: {
      default: () => ({}),
      type: Object
    },
    noWrapper: {
      default: false,
      type: Boolean,
    },
    autoFocus: {
      default: true,
      type: Boolean
    },
    enterSubmit: {
      default: true,
      type: Boolean
    },
    closeable: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    elProps: {
      type: Object,
      default: () => {}
    },
    disableClose: {
      type: Boolean,
      default: false
    },
    hideWhenRouterChange: {
      type: Boolean,
      default: true
    },
    perventCloseBtnCb: {
      type: Function,
      default: null
    }
  },
  computed: {
    hasSlot() {
      return Boolean(this.$slots.default)
    },
    hasClickProp() {
      if (this.elProps && this.elProps.hasOwnProperty('close-on-click-modal') && this.elProps['close-on-click-modal'] === false) {
        return true
      }
      return false
    },
    ...mapGetters(['active_dialogs']),
  },
  data() {
    return {
      uid: this._uid,
      show: false,
      inputs: [],
      mousedown_wrapper_flag: false,
      is_never_show: false,
    }
  },
  watch: {
    value: {
      handler (v) {
        this.show = v
      },
      immediate: true
    },
    show(v) {
      this.$emit('input', v);
    },
    '$route' () {
      if (this.hideWhenRouterChange) {
        this.show = false
      }
    }
  },
  beforeDestroy () {
    this.removeStack()
  },
  methods: {
    opened () {
      if ((this.autoFocus || this.enterSubmit) && !this.noWrapper) { 
        this.inputs = this.$refs['dialog-wrapper'].querySelectorAll('input:not([type="file"]):not([readonly]):not([disabled])')
        if (this.inputs.length) {
          if (this.autoFocus) {
            const firstInput = this.inputs.length ? this.inputs[0] : null
            firstInput && firstInput.focus()
          }
          if (this.enterSubmit) {
            const last_input = this.inputs[this.inputs.length - 1]
            last_input.addEventListener('keydown', this.keydownSubmit)
          }
        }
      }
      this.pushStack()
      this.$emit('opened')
    },
    open () {
      this.$emit('open')
    },
    beforeClose (down) {
      if (this.active_dialogs[this.active_dialogs.length - 1] === this.uid) {
        down()
      }
    },
    close () {
      this.$emit('close', this.config.neverShow ? {is_never_show: this.is_never_show} : undefined)
    },
    closed () {
      if (this.inputs.length && this.enterSubmit) {
        const last_input = this.inputs[this.inputs.length - 1]
        last_input.removeEventListener('keydown', this.keydownSubmit)
      }
      this.removeStack()
      this.$emit('closed')
    },
    handleClickCloseBtn () {
      if (this.perventCloseBtnCb) {
        this.perventCloseBtnCb()
        return
      }
      this.show = false
      
    },
    handleTextBtn () {
      this.$emit('textBtn', this.config.neverShow ? {is_never_show: this.is_never_show} : undefined)
    },
    handleCancel () {
      this.show = false
      this.$emit('cancel', this.config.neverShow ? {is_never_show: this.is_never_show} : undefined)
    },
    confirmCallBack() {
      if (!this.show) return;
      this.$emit('confirm', this.config.neverShow ? {is_never_show: this.is_never_show} : undefined);
    },
    keydownSubmit(e) {
      if (e.keyCode === 13) {
        this.confirmCallBack()
      }
    },
    pushStack () {
      this.active_dialogs.push(this.uid)
    },
    removeStack () {
      const index = this.active_dialogs.indexOf(this.uid)
      if (index > -1) {
        this.active_dialogs.splice(index, 1)
      }
    },

    handleMouseDown (e) {
      if (this.disableClose || this.hasClickProp) return;
      this.mousedown_wrapper_flag = true
    },
    handleMouseUp (e) {
      if (this.disableClose || this.hasClickProp) return;
      if (this.mousedown_wrapper_flag) {
        this.show = false
      }
      this.mousedown_wrapper_flag = false
    }
  }
}
</script>

<style lang="scss">
.chat-dialog-wrapper {
  width: 416px;
  max-height: calc(100vh - 100px);
  padding: 24px 0px;
  border-radius: 12px;
  background-color: $d-fl-1;
  display: flex;
  flex-direction: column;
  &.primary {
    .dialog-title-group {
      padding-bottom: 12px;
      background: $d-bg-ln-3;
      .title {
        color: $ct-wh-0;
      }
      .desc {
        color: $ct-wh-4;
      }
    }
    .slot-wrapper {
      color: $d-tx-2;
    }
  }
  .close-btn {
    i {
      font-size: 15px;
    }
  }
  .dialog-title-group {
    // margin-bottom: 20px;
    margin-top: -24px;
    padding: 24px 24px 20px 24px;
    border-radius: 12px 12px 0px 0px;
    .title {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0.01em;
      color: $d-tx-1;
    }
    .desc {
      margin-top: 6px;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.04em;
      color: $d-tx-3;
    }
    &.gradient {
      background: $d-bg-ln-3;
      .desc {
        color: $d-tx-1;
      }
    }
    &.dark {
      background: $d-fl-3;
    }
  }
  .slot-wrapper {
    padding: 0px 24px;
    overflow-y: auto;
    overflow-y: overlay;
    display: flex;
    flex-direction: column;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .btn-wrapper {
    width: 100%;
    height: 42px;
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0px 24px;
    flex-shrink: 0;
    &.no-mg {
      margin-top: 0;
    }
    .btn {
      width: 114px;
      margin-left: 10px;
      border-radius: 5px;
    }
    .text-btn {
      line-height: 24px;
      font-size: 14px;
      color: $d-tx-3;
      cursor: pointer;
    }
  }
  .never-show-row {
    position: absolute;
    bottom: 36px;
    left: 24px;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.01em;
    color: $d-tx-3;
    cursor: pointer;
    z-index: 1;
    .radio {
      width: 16px;
      height: 16px;
      border: 2px solid #42464d;
      margin-right: 6px;
      border-radius: 2px;
      &.active {
        border: 0;
      }
      .iconfont {
        font-size: 16px;
        color: $d-bd-tx;
      }
    }
    p {
      padding-bottom: 2px;
    }
  }
}
</style>
